<template>
  <el-container style="height:100%;">
    <el-header class="task-header" style="padding-right: 0;">
      <div class="course-title">
        <div v-if="!renameExamNameVisible">
          <span class="coursename">{{examname?examname:'活动名称'}}</span>
          <span command="rename" @click="renameExamname" class="btn-edit">
            <i class="el-icon-edit"></i>
            修改
          </span>
        </div>
        <el-form :model="renameform" ref="renameform" @submit.native.prevent :rules="renameRules" v-if="renameExamNameVisible" class="renameform">
          <el-form-item prop="name" style="margin-top: 10px;">
            <el-input v-model.trim="renameform.name" v-focus autocomplete="off" autofocus="true" @blur="paperNameSubmit('renameform')" @keyup.enter.native="$event.target.blur">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="fr" style="width: 260px;">
        <el-button size="medium" style="margin:0 20px 0 0;" @click="previewPaper">预览</el-button>
        <el-button size="medium" style="margin: 0 20px 0 0;" @click="saveActivity">保存</el-button>
        <el-button size="medium" style="margin:0;" @click="closeActivity">关闭</el-button>
      </div>
      <el-dialog title="试卷设置" class="examset" :visible.sync="dialogExamVisible" :append-to-body="true" :close-on-click-modal="false" :before-close="close" top="7vh">
        <ExamSet @close="close" ref="mychild" :paperId="paperId" :paperData="paperData" v-if="dialogExamVisible"></ExamSet>
      </el-dialog>
    </el-header>
    <el-container style="overflow-y: hidden;height:calc(100% - 60px);">
      <el-main class="exam-main" v-if="paperId">
        <Paper ref="myexam" :paperId="paperId" />
      </el-main>
    </el-container>
    <div class="shade-model" v-if="renameExamNameVisible"></div>
  </el-container>
</template>

<script>
import Paper from '@/components/test/Paper';
import draggable from "vuedraggable";
import ExamSet from "@/components/test/ExamSet";
import { selectTargetProjectTaskActivityData, savePaperTitleData } from "@/api/contest";
import oss from '@/utils/aliOss'
import { format } from 'path';
let id = 1;
export default {
  components: {
    draggable,
    Paper,
    ExamSet,
  },
  beforeDestroy() {
    this.$root.$off('returnexam')
    this.$root.$off('returndialog')
  },
  watch: {
    is_parsing: function () {
      if (this.$refs.myexam) {
        this.$refs.myexam.showAnswer = this.is_parsing
      }
    }
  },
  data() {
    return {
      visible: false,
      examname: '',
      paperId: '',//试卷id
      taskId: '',//上级任务id
      paperData: [],//试卷设置内容
      is_parsing: 0,
      dialogExamVisible: false,
      renameExamNameVisible: false,
      renameform: {
        name: ''
      },
      list: [],
      dragging: false,
      renameRules: {
        name: [
          { required: true, message: "请输入1-30位字符!", trigger: "blur" },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value.length > 30 || !value) {
                callback('请输入1-30位字符!');
              }
              callback(errors);
            }
          }
        ],
      }
    }
  },
  created() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  mounted() {
    window.onbeforeunload = (e) => {
      if (this.$route.fullPath === "/contest/create-paper") {
        e = e || window.event;
        if (e) {
          e.returnValue = '关闭提示';
        }
        return '关闭提示';
      }
    }
    let eventInfo = JSON.parse(sessionStorage.getItem('eventInfo'));
    this.paperId = eventInfo.paperId
    this.taskId = eventInfo.taskId
    sessionStorage.setItem('taskId', this.taskId)
    if (!this.paperId) {
      this.dialogExamVisible = true
    } else {
      this.initData()
    }
    this.$root.$on('returnexam', (subjectObj) => {
      this.dialogExamVisible = false
      this.examname = subjectObj.paper_title
      this.paperData.paper_title = subjectObj.paper_title
      this.paperId = subjectObj.paper_id
      let eventInfo = JSON.parse(sessionStorage.getItem('eventInfo'));
      eventInfo.paperId = this.paperId
      sessionStorage.setItem('eventInfo', JSON.stringify(eventInfo))
      this.initData()
    })
    this.$root.$on('returndialog', (obj) => {
      this.dialogExamVisible = obj.dialogExamVisible
    })
  },
  methods: {
    initData: function () {
      let params = {
        paper_id: this.paperId,
        activity_type: 4
      }
      selectTargetProjectTaskActivityData(params).then(response => {
        this.examname = response.data.paper_title
        this.paperData = response.data
        this.is_parsing = response.data.is_parsing
      })
    },
    renameExamname: function () {
      this.renameExamNameVisible = true;
      this.renameform.name = this.examname;
    },
    //试卷重命名
    paperNameSubmit: function (formName) {
      if (this.renameform.name === this.examname) {
        this.renameExamNameVisible = false;
        this.renameform.name = ''
        return true
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            task_id: this.taskId,
            paper_id: this.paperId,
            paper_title: this.renameform.name
          }
          this.renameExamNameVisible = false;
          savePaperTitleData(params).then(response => {
            this.examname = this.renameform.name
            this.paperData.paper_title = this.examname
            this.$message.success('修改成功')
          })
        }
      })
    },
    //保存整个试卷
    saveActivity: function () {
      if (!this.paperId) {
        return
      }
      this.$refs.myexam.savePaper()
    },
    //关闭整个试卷
    closeActivity: function () {
      this.$router.go(-1);//返回上一层
    },
    //预览试卷
    previewPaper: function () {
      sessionStorage.setItem('paperId', this.paperId)
      const routeData = this.$router.resolve({ name: "paper-preview" })
      window.open(routeData.href, '_blank')
    },
    close: function () {
      if (this.paperId) {
        this.dialogExamVisible = false
      } else {
        this.$confirm('是否退出编辑', '退出编辑', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(_ => {
          this.$router.go(-1);//返回上一层
        }).catch(_ => { })
      }
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    },
  },

};
</script>

<style scoped>
@import "../../assets/css/examine.css";
</style>